// extracted by mini-css-extract-plugin
module.exports = {"lastUpdate__box":"style_lastUpdate__box__2IAF1","strong":"style_strong__3Sjrp"};